import MenuName from "@/pages/components/MenuName/index.jsx";
import SvgIcon from "@/pages/components/SvgIcon/index.jsx";
import { 
  DashboardOutlined,
  AppstoreOutlined, 
  UserOutlined,
  ShoppingCartOutlined,
  CrownOutlined,
  BankOutlined,
  NodeIndexOutlined,
  AuditOutlined,
  DatabaseOutlined,
  ClusterOutlined,
  GiftOutlined
} from "@ant-design/icons";

const menus = [
  {
    key: '/',
    label: '数据看板',
    icon: <DashboardOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },
  {
    key: '/application-manager',
    label:'应用管理',
    icon: <AppstoreOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/channel-application',
        label: '渠道应用',
      },{
        key: '/home-application',
        label: '首页应用',
      },{
        key: '/customer-application',
        label: '客户应用',
      },
    ]
  },
  {
    key: '/customer',
    label:'客户管理',
    icon: <UserOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/customer/list',
        label: '客户列表',
      },{
        key: '/customer/invite',
        label: '专属链接客户',
      },
    ]
  },
  {
    key: '/order-center',
    label: '订单中心',//'智能作图',
    icon: <ShoppingCartOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },

  {
    key: '/package-management',
    label:'套餐&算力管理',
    icon: <GiftOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },

  {
    key: '/marketing',
    label:'营销管理',
    icon: <CrownOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/marketing/salesman',
        label: '营销成员',
      },
      {
        key: '/marketing/redemption-code',
        label: '兑换码',
      },
    ]
  },
  {
    key: '/enterprise',
    label:'企业管理',
    icon: <BankOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/enterprise/list',
        label: '企业套餐',
      },
    ]
  },
  {
    key: '/workflow-management',
    label:'工作流管理',
    icon: <NodeIndexOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/workflow-management/label',
        label: '标签管理',
      },
      {
        key: '/workflow-management/classification',
        label: '分类管理',
      },
      {
        key: '/workflow-management/workflow',
        label: '工作流管理',
      },
      {
        key: '/workflow-management/agent',
        label: '智能体管理',
      },
      {
        key: '/workflow-management/compute-rule',
        label: '算力规则管理',
      },
    ]
  },
  {
    key: '/content',
    label: '内容管理',
    icon: <AuditOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },
  {
    key: '/gpu-pool',
    label: 'GPU池管理',
    icon: <DatabaseOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },
  {
    key: '/task-management',
    label: '任务管理',
    icon: <ClusterOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },
];

export default menus;